import { render, staticRenderFns } from "./mrHeadBox.vue?vue&type=template&id=ef183e3e&scoped=true"
import script from "./mrHeadBox.vue?vue&type=script&lang=js"
export * from "./mrHeadBox.vue?vue&type=script&lang=js"
import style0 from "./mrHeadBox.vue?vue&type=style&index=0&id=ef183e3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef183e3e",
  null
  
)

export default component.exports